var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-apex-chart',{attrs:{"type":"bar","series":_vm.chart.series,"options":_vm.chart.options,"card_height":"230","height":"100%","tile":"","animated":"","toolbar":false}})}
var staticRenderFns = []

export { render, staticRenderFns }